import React, { useState } from 'react';
import { TripSuggestionStyles, StyledButtons } from '../survey-helpers/trip-suggestion/trip-suggestion-styles';
import { doc, runTransaction } from "firebase/firestore";
import { db } from '../../firebase';

const DisplayResults = ({ rankings, DestinationRankings, handleViewResults, showSignUpModal, user, docId }) => {
    const userId = user?.uid || "Other";
    const [rated, setRated] = useState({});

    const handleRating = async (index, rating) => {
      if (!docId) {
        console.warn('No docId provided for feedback write');
        return;
      }
      const resultDoc = doc(db, "Results", userId, "Game", docId);

      try {
        await runTransaction(db, async (transaction) => {
          const snap = await transaction.get(resultDoc);
          const data = snap.exists() ? snap.data() : {};
          const feedback = Array.isArray(data.feedback) ? [...data.feedback] : [];
          while (feedback.length <= index) feedback.push(null);
          feedback[index] = rating;
          transaction.update(resultDoc, { feedback });
        });
        // mark as rated locally so UI collapses
        setRated(prev => ({ ...prev, [index]: true }));
      } catch (err) {
        console.error('Failed to write feedback:', err);
      }
    };
  
    return (
      <TripSuggestionStyles>
        <div className="header">
          <div className="title-container">
            <h1 className="your-preferences">Your Suggestions:</h1>
          </div>
          <div className="description-container">
            <button onClick={() => handleViewResults()} className='header-button'>
              Continue Selecting
            </button>
            {!user ? (
              <button onClick={() => showSignUpModal(true)} className='header-button'>
                Save Results
              </button>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div>
          {rankings.slice(0, 8).map((ranking, index) => {
            const destination = DestinationRankings[ranking.city];
            if (!destination) return null; // Ensure destination exists
          
            return (
              <div key={index} className="row gy-3 box p-3 mb-5">
                <div className="col-12 d-flex flex-row justify-content-between align-items-center mt-0">
                  <div className='left-container'>
                    <span className="package-description text-center text-md-start">
                      {index + 1}. {ranking.city}
                    </span>
                    <div className='button-container'>
                      <div className={`feedback-buttons ${rated[index] ? 'hidden' : 'visible'}`}>
                        <p className='description'>Do you like this suggestion?</p>
                        <StyledButtons
                          className="dislike"
                          onClick={() => handleRating(index, -1)}
                        ></StyledButtons>
                        <StyledButtons
                          className="like"
                          onClick={() => handleRating(index, 1)}
                        ></StyledButtons>
                      </div>
                      <p className={`description thank-you ${rated[index] ? 'visible' : ''}`}>Thank you for your feedback.</p>
                    </div>
                  </div>
                  
                  <img className="img-fluid" src={destination.image} alt={ranking.city} />
                </div>
              </div>
            );
          })}
        </div>
      </TripSuggestionStyles>
    );
  };
  
  export default DisplayResults;